import { setSelectedCycle } from "../../handler/ParentDataHandler";
import { DEFAULT_CYCLE } from "../utils/Constants";

export const CycleFilterReducer = (state, action) => {
  switch (action.type) {
    case "INITIALIZE_CYCLES":
      let allCycles = JSON.parse(action.cycleData.cycleList)
        .filter((cycle) => cycle.cycleId !== "AllCycles")
        .map((cycle) => {
          return {
            ...cycle,
            displayableName: cycle.cycleId,
          };
        })
        .sort((cycle1, cycle2) =>
          cycle1.cycleName > cycle2.cycleName
            ? 1
            : cycle2.cycleName > cycle1.cycleName
              ? -1
              : 0,
        );
      let selectedCycles = JSON.parse(action.cycleData.selectedCycles).filter(
        (cycle) => cycle !== "AllCycles",
      );

      if (
        action.cycleData.defaultCycleFilter &&
        selectedCycles &&
        selectedCycles[0] !== DEFAULT_CYCLE
      ) {
        allCycles.forEach((cycle) => {
          if (cycle.cycleName && cycle.cycleName === DEFAULT_CYCLE) {
            selectedCycles[0] = DEFAULT_CYCLE;
          }
        });
      }

      return {
        ...state,
        selectedCycles: selectedCycles,
        allCycles: allCycles,
      };
    case "SELECT_CYCLE":
      setSelectedCycle([action.cycle]);
      return {
        ...state,
        selectedCycles: [action.cycle],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/overview/reducers/CycleFilterReducer.js